let dragActive = false;
let dragClearTimer = null;

export const isFlickityDragActive = () => dragActive;

export const markFlickityDragStart = () => {
  if (dragClearTimer) {
    window.clearTimeout(dragClearTimer);
    dragClearTimer = null;
  }
  dragActive = true;
};

export const markFlickityDragEnd = () => {
  if (dragClearTimer) {
    window.clearTimeout(dragClearTimer);
  }
  dragClearTimer = window.setTimeout(() => {
    dragActive = false;
    dragClearTimer = null;
  }, 150);
};
